import driverFacesSliceRedux from '../views/driverFacesTable/redux/slices'
import driverTagsSliceRedux from '../views/tagsTable/redux/slice'
import driverChangeStatusSliceRedux from '../views/driverTable/components/changeStatus/redux/slices'
import driverTimeClockSliceRedux from '../views/driverTable/components/timeClock/redux/slice'
import driverImportDriverSliceRedux from '../views/driverTable/components/importDriver/redux/slices'
import driverTableSliceRedux from '../views/driverTable/components/table/redux/slices'
import driverCreateEditSliceRedux from '../views/driverTable/components/createEditDriver/redux/slices'
import driverDeleteDriverSliceRedux from '../views/driverTable/components/deleteDriver/redux/slice'
import driverResetPasswordSliceRedux from '../views/driverTable/components/resetPasswordDriver/redux/slices'

export default {
    driverFacesSliceRedux,
    driverTagsSliceRedux,
    driverChangeStatusSliceRedux,
    driverTimeClockSliceRedux,
    driverImportDriverSliceRedux,
    driverTableSliceRedux,
    driverCreateEditSliceRedux,
    driverDeleteDriverSliceRedux,
    driverResetPasswordSliceRedux
}